




















import Vue from 'vue'
export default Vue.extend({
  name: 'CheckInItem',
  props: {
    amount: {
      type: Number,
      required: true
    },
    id: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    latitude: {
      type: Number,
      required: true
    },
    longitude: {
      type: Number,
      required: true
    },
    location: {
      type: String,
      required: true
    },
    distance: {
      type: String,
      required: true
    },
    isCheckIn: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    handleClick() {
      this.$emit('handleCheckIn', {
        stamp_id: this.id,
        latitude: this.latitude,
        longitude: this.longitude
      })
    }
  }
})
